//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
import { BannerStrip } from '@/containers-m/BannerStrip';

//context containers
import {
  Hero,
  SegmentNavigation,
  IntroductionText,
  CustomersLogos,
  Featured,
  SidePanels,
  LifeLoadVideo,
  ShipWithUs,
  Newsroom,
  ImageCTA,
  LogoImageCTA,
} from './containers/index';

//styles
import { PageWrapper } from './Home.styles';

const bannerContent = (
  <p>
    Ship any load, any mode, anywhere. <br />{' '}
    <a
      href={`${process.env.SHIPPERGUIDE_URL}/signup?utm_source=loadsmart&utm_medium=banner&utm_campaign=free-account-creation-midmarket-shipperguide-q1-23&utm_content=quoting-bar-home-page`}
      target="_blank"
      rel="noopener noreferrer"
    >
      Sign up now
    </a>{' '}
    for free and get <br /> shipping quotes instantly.
  </p>
);

function Home() {
  return (
    <PageWrapper>
      <Navigation theme="light" />
      <>
        <BannerStrip content={bannerContent} />
        <Hero />
        <SegmentNavigation />
        <IntroductionText />
        <ImageCTA />
        <LogoImageCTA />
        <SidePanels />
        <Featured />
        <LifeLoadVideo />
        <CustomersLogos />
        <Newsroom />
        <ShipWithUs />
      </>
      <Footer />
    </PageWrapper>
  );
}

export default Home;
export { Home };
